import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDrivePreferences,
  getProfile,
  manageDrivePreferences,
  updateProfile,
} from "store/services/profile";
import { uploadFile } from "store/services/utilities";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { openToast } from "store/slices/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetProfileAction = createAsyncThunk(
  "profile/getProfile",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getProfile(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetDrivePrefrenceAction = createAsyncThunk(
  "profile/getDrivePrefrence",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const response = await getDrivePreferences(payload);
      if (response.status === 1) {
        return fulfillWithValue(response);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const ManageDrivePrefrenceAction = createAsyncThunk(
  "profile/postDrivePrefrence",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const response = await manageDrivePreferences(rest);
      if (response.status === 1) {
        onSuccess?.();
        return fulfillWithValue(response);
      }
      onError && onError();
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(response?.statusCode),
        }),
      );
      return rejectWithValue(response);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const UpdateProfileAction = createAsyncThunk(
  "profile/updateProfile",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { file, onSuccess, onError, ...rest } = payload;
      if (file) {
        const uploadFilesResponse = await uploadFile({
          file: [file],
          uploadFor: "profile",
        });
        if (uploadFilesResponse.status === 0) {
          return rejectWithValue(uploadFilesResponse);
        }
        rest.profile = uploadFilesResponse.response.urls[0];
      }
      const response = await updateProfile(rest);
      if (response.status === 1) {
        onSuccess && onSuccess();
        dispatch(closeCenterModal());
        return fulfillWithValue(response);
      }
      onError && onError();
      dispatch(
        openToast({
          type: "error",
          message: response?.statusCode
            ? getApiMessage(response?.statusCode)
            : response?.message,
        }),
      );
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
